import { defineMessages, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { ExperienceBlock } from '@sorare/core/src/components/landing/ExperienceBlock';
import { messages } from '@sorare/core/src/components/landing/LandingMultiSport/Experience';
import { FOOTBALL_MARKET } from '@sorare/core/src/constants/__generated__/routes';

import competeImage from './assets/compete.jpg';
import competeImageMobile from './assets/competeMobile.jpg';
import createImage from './assets/create.jpg';
import createImageMobile from './assets/createMobile.jpg';
import strengthenImage from './assets/strengthen.jpg';
import strengthenImageMobile from './assets/strengthenMobile.jpg';
import winRewardsImage from './assets/winRewards.jpg';
import winRewardsImageMobile from './assets/winRewardsMobile.jpg';

const footballMessages = defineMessages({
  buildTeamTitle: {
    id: 'Football.Landing.BuildTeam.title',
    defaultMessage: 'Build Your Team',
  },
  buildTeamText: {
    id: 'Football.Landing.BuildTeam.text',
    defaultMessage:
      'Create your ultimate fantasy club by scouting and collecting player cards from over 300 clubs around the globe. Set your starting lineup and compete in free, twice-weekly competitions for prizes based on your players’ real-life performance. Start playing at any point in the season.{br}{br}Sorare’s skill-based game rewards your football knowledge and lineup-building strategy.',
  },
  competeText: {
    id: 'Football.Landing.Compete.text',
    defaultMessage:
      'Get familiar with Sorare Football in our beginner competitions with free Common Cards and level up. As you progress and climb leaderboards, you’ll collect higher-level player cards to play in advanced contests with bigger prizes.{br}{br} <em>Sorare competitions are free to play.</em>',
  },
  strengthenText: {
    id: 'Football.Landing.Strengthen.text',
    defaultMessage:
      'Use Sorare’s live Marketplace – which features thousands of footballers – to scout, buy, sell, and trade cards of varying scarcities to unlock higher-level competitions and rewards.{br}{br} Improve your lineups by adding proven performers for an immediate boost, or next-generation stars for long-term production.',
  },
  winRewardsText: {
    id: 'Football.Landing.WinRewards.text',
    defaultMessage:
      'Compete for prizes such as cash, ETH, Sorare cards, game tickets, jerseys, gear, and access to Footballers and VIP experiences.',
  },
});

export const Experience = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <ExperienceBlock
      title={formatMessage({
        id: 'Landing.Football.Experience.title',
        defaultMessage: 'Experience Fantasy Football Like A Professional Owner',
      })}
      blocks={[
        {
          title: formatMessage(footballMessages.buildTeamTitle),
          text: formatMessage(footballMessages.buildTeamText, { br: <br /> }),
          imageSrc: { default: createImage, mobile: createImageMobile },
        },
        {
          title: formatMessage(messages.competeTitle),
          text: formatMessage(footballMessages.competeText, {
            br: <br />,
            em: (...chunks) => <em>{chunks}</em>,
          }),
          imageSrc: { default: competeImage, mobile: competeImageMobile },
        },
        {
          title: formatMessage(messages.strengthenTitle),
          text: formatMessage(footballMessages.strengthenText, { br: <br /> }),
          cta: formatMessage(messages.strengthenCTA),
          ctaAction: () => navigate(FOOTBALL_MARKET),
          imageSrc: { default: strengthenImage, mobile: strengthenImageMobile },
        },
        {
          title: formatMessage(messages.winRewardsTitle),
          text: formatMessage(footballMessages.winRewardsText, { br: <br /> }),
          imageSrc: {
            default: winRewardsImage,
            mobile: winRewardsImageMobile,
          },
        },
      ]}
    />
  );
};
